var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.159,
    height: 24.259,
    viewBox: "0 0 24.159 24.259",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_93737",
    "data-name": "Path 93737",
    d: "M22.164,2.1A7.743,7.743,0,0,0,16.981,0,7.536,7.536,0,0,0,11.8,2.1a1.658,1.658,0,0,0-.441,1.213A2.312,2.312,0,0,0,11.8,4.521a1.658,1.658,0,0,0,1.213.441h0a2.312,2.312,0,0,0,1.213-.441,4.129,4.129,0,0,1,5.734,0,4.65,4.65,0,0,1,.992,2.757,4,4,0,0,1-1.213,2.867l-9.593,9.593a4.129,4.129,0,0,1-5.734,0,4.124,4.124,0,0,1-1.1-2.757,4,4,0,0,1,1.213-2.867l4.08-4.08a1.2,1.2,0,0,1,1.654,0,1.342,1.342,0,0,1,0,1.764L7.278,14.776a1.658,1.658,0,0,0-.441,1.213A2.312,2.312,0,0,0,7.278,17.2a1.828,1.828,0,0,0,2.316,0l2.977-2.977a4.526,4.526,0,0,0,0-6.4,4.416,4.416,0,0,0-3.2-1.323A3.917,3.917,0,0,0,6.285,7.719L2.205,11.8A7,7,0,0,0,0,16.981a7.536,7.536,0,0,0,2.1,5.183,7.743,7.743,0,0,0,5.183,2.1,7.536,7.536,0,0,0,5.183-2.1l9.593-9.593a7.071,7.071,0,0,0,2.1-5.183A7.223,7.223,0,0,0,22.164,2.1Z",
    fill: "#4c34ad"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.1d303aba1164ee3cf827538c9fb81d56.svg";
export { ForwardRef as ReactComponent };